import { Center, Grid, Group, Loader, Notification, Title } from '@mantine/core'
import { useDocumentTitle, useToggle } from '@mantine/hooks'
import { useQuery } from '@tanstack/react-query'
import { createRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { LocationsShowingMovie } from '../components/locations_showing_movie.tsx'
import { MovieCard } from '../components/movie_card.tsx'
import { Filters } from '../components/movie_filters.tsx'
import { trpc } from '../queryClient.ts'
import { rootRoute } from '../root.tsx'
import { useErrorNotifier } from '../tools/errors.tsx'

export const currentlyOutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: InCinemas,
})

function InCinemas() {
  useDocumentTitle('Mewview Watchcat')
  const [showHidden, toggleHidden] = useToggle()
  const [selectedLocation, setSelectedLocation] = useState<string | undefined>(undefined)

  return (
    <div>
      <Group justify="space-between">
        <Title pb="sm">In cinemas now</Title>
        <Filters showHidden={showHidden} onToggleShowHidden={toggleHidden} onLocationSelect={setSelectedLocation}/>
      </Group>
      <MoviesInCinemaList showHidden={showHidden} filterByLocation={selectedLocation}/>
    </div>
  )
}

function MoviesInCinemaList({ showHidden, filterByLocation }: { showHidden?: boolean; filterByLocation?: string }) {
  const { data, isLoading, error } = useQuery(trpc.moviesInCinemas.queryOptions({ includeHidden: showHidden, location: filterByLocation }))
  useErrorNotifier('Error fetching movies in cinemas', error)

  if (isLoading && !data) return <Center h="100px"><Loader type="dots"/></Center>

  if (error) {
    return (
      <Notification withCloseButton={false} title="An error occurred fetching movies" color="red">
        {error.message}
      </Notification>
    )
  }
  if (!data?.length) {
    return <div>No movies are currently in cinemas that you haven't hidden.</div>
  }
  return (
    <Grid gutter={{ base: 'xs', sm: 'md', md: 'lg' }}>
      {data.map(movie => (
        <Grid.Col span={{ xs: 12, sm: 6 }} key={movie.id}>
          <MovieCard movie={movie}>
            <LocationsShowingMovie movieTimes={movie.times}/>
          </MovieCard>
        </Grid.Col>
      ))}
    </Grid>
  )
}
